import cssJoin from '../cssJoin';
import filterClassNames from './filterClassNames';
/**
 * Join optional and string classNames.
 *
 * @param classNames Classnames to join.
 */
export const classes = (...classNames) =>
  classNames
    .map(className =>
      Array.isArray(className) ? cssJoin(...className) : className
    )
    .map(className =>
      typeof className === 'string'
        ? className.trim().split(' ')
        : filterClassNames(className)
    )
    .reduce((output, classNameArray) => [...output, ...classNameArray], [])
    .join(' ') || void 0;
export default classes;
